export default "__VITE_ASSET__BEB926pw__"